import { render, staticRenderFns } from "./a-footer.vue?vue&type=template&id=9b6365e2&scoped=true"
import script from "./a-footer.vue?vue&type=script&lang=js"
export * from "./a-footer.vue?vue&type=script&lang=js"
import style0 from "./a-footer.vue?vue&type=style&index=0&id=9b6365e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6365e2",
  null
  
)

export default component.exports